'use strict';

import hits from './hits';
import popularIn from './popularIn.js';

export default {
  hits,
  popularIn
}
